export const PROMOTION_VIEWS = Object.freeze({
  bump: 'service_bump',
  vip: 'service_vip',
  feature: 'service_feature',
  restore: 'restore',
  limitPayment: 'limit_payment',
  personalAds: 'personal_ads'
});

export type PromotionView =
  (typeof PROMOTION_VIEWS)[keyof typeof PROMOTION_VIEWS];

export const PROMOTION_SERVICE_VIEWS: PromotionView[] = [
  PROMOTION_VIEWS.bump,
  PROMOTION_VIEWS.vip,
  PROMOTION_VIEWS.feature
];
